// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questionnaire-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    backdrop-filter: blur(5px);
}

.questionnaire-modal-container {
    background: white;
    width: 95%;
    max-width: 600px;
    border-radius: 12px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.questionnaire-modal-header {
    background: linear-gradient(135deg, #1a73e8, #4285f4);
    padding: 1.5rem;
    position: relative;
}

.questionnaire-modal-header h2 {
    color: white;
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
}

.modal-close-btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: transparent;
    border: none;
    color: white;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0.5rem;
    line-height: 1;
    transition: transform 0.2s;
}

.modal-close-btn:hover {
    transform: rotate(90deg);
}

.questionnaire-form {
    padding: 2rem;
}

.form-section {
    margin-bottom: 1.5rem;
}

.form-label {
    display: block;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.5rem;
}

.form-select {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background-color: #f9fafb;
    color: #1f2937;
    transition: all 0.2s;
    font-size: 1rem;
}

.form-select:focus {
    outline: none;
    border-color: #1a73e8;
    box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
    background-color: white;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid #e5e7eb;
}

.cancel-btn, .submit-btn {
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.2s;
}

.cancel-btn {
    background-color: white;
    border: 1px solid #e5e7eb;
    color: #374151;
}

.cancel-btn:hover {
    background-color: #f9fafb;
    border-color: #d1d5db;
}

.submit-btn {
    background: linear-gradient(135deg, #1a73e8, #4285f4);
    color: white;
    border: none;
}

.submit-btn:hover {
    background: linear-gradient(135deg, #1557b0, #2d6cd4);
    transform: translateY(-1px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

@keyframes modalSlideIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.questionnaire-modal-container {
    animation: modalSlideIn 0.3s ease-out;
}

.flex_dis{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/EditQuestionnaire.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;IACrD,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;IAC7C,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,qDAAqD;IACrD,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;AACf","sourcesContent":[".questionnaire-modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.75);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    backdrop-filter: blur(5px);\n}\n\n.questionnaire-modal-container {\n    background: white;\n    width: 95%;\n    max-width: 600px;\n    border-radius: 12px;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n}\n\n.questionnaire-modal-header {\n    background: linear-gradient(135deg, #1a73e8, #4285f4);\n    padding: 1.5rem;\n    position: relative;\n}\n\n.questionnaire-modal-header h2 {\n    color: white;\n    margin: 0;\n    font-size: 1.5rem;\n    font-weight: 600;\n    text-align: center;\n}\n\n.modal-close-btn {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    background: transparent;\n    border: none;\n    color: white;\n    font-size: 1.5rem;\n    cursor: pointer;\n    padding: 0.5rem;\n    line-height: 1;\n    transition: transform 0.2s;\n}\n\n.modal-close-btn:hover {\n    transform: rotate(90deg);\n}\n\n.questionnaire-form {\n    padding: 2rem;\n}\n\n.form-section {\n    margin-bottom: 1.5rem;\n}\n\n.form-label {\n    display: block;\n    font-weight: 500;\n    color: #374151;\n    margin-bottom: 0.5rem;\n}\n\n.form-select {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    background-color: #f9fafb;\n    color: #1f2937;\n    transition: all 0.2s;\n    font-size: 1rem;\n}\n\n.form-select:focus {\n    outline: none;\n    border-color: #1a73e8;\n    box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n    background-color: white;\n}\n\n.modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    margin-top: 2rem;\n    padding-top: 1.5rem;\n    border-top: 1px solid #e5e7eb;\n}\n\n.cancel-btn, .submit-btn {\n    padding: 0.75rem 1.5rem;\n    border-radius: 6px;\n    font-weight: 500;\n    transition: all 0.2s;\n}\n\n.cancel-btn {\n    background-color: white;\n    border: 1px solid #e5e7eb;\n    color: #374151;\n}\n\n.cancel-btn:hover {\n    background-color: #f9fafb;\n    border-color: #d1d5db;\n}\n\n.submit-btn {\n    background: linear-gradient(135deg, #1a73e8, #4285f4);\n    color: white;\n    border: none;\n}\n\n.submit-btn:hover {\n    background: linear-gradient(135deg, #1557b0, #2d6cd4);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n@keyframes modalSlideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.questionnaire-modal-container {\n    animation: modalSlideIn 0.3s ease-out;\n}\n\n.flex_dis{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
